import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VoiceService {
  recognition: any;
  isListening: boolean = false;
  finalTranscript: string = '';
  public products$ = new BehaviorSubject<any[]>([]);
  public interimText$ = new BehaviorSubject<string>('');

  constructor(private zone: NgZone, private http: HttpClient) {
    const { webkitSpeechRecognition }: any = window as any;

    if (!webkitSpeechRecognition) {
      alert('Your browser does not support Speech Recognition!');
      return;
    }

    this.recognition = new webkitSpeechRecognition();
    this.recognition.lang = 'en-US';
    this.recognition.continuous = true;
    this.recognition.interimResults = true;

    this.recognition.onresult = (event: any) => {
      let interimTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const transcriptPiece = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          this.finalTranscript += transcriptPiece + ' ';
        } else {
          interimTranscript += transcriptPiece + ' ';
        }
      }

      const currentTranscript = this.finalTranscript + interimTranscript;
      this.zone.run(() => this.interimText$.next(currentTranscript));

      // Send text to backend every update
      this.sendTextToBackend(currentTranscript);
    };

    this.recognition.onend = () => {
      this.isListening = false;
    };

    this.recognition.onerror = (event: any) => {
      console.error('Speech recognition error:', event.error);
      this.isListening = false;
    };
  }

  startListening() {
    if (!this.isListening) {
      try {
        this.recognition.start();
        this.isListening = true;
      } catch (err) {
        console.warn('Recognition could not start:', err);
      }
    }
  }

  stopListening() {
    if (this.isListening) {
      this.recognition.stop();
      this.isListening = false;
    }
  }

  private sendTextToBackend(text: string) {
    this.http.post<any[]>('http://localhost:9900/parse-live', { text })
      .subscribe({
        next: (res) => this.zone.run(() => this.products$.next(res)),
        error: (err) => console.error('Backend error:', err)
      });
  }
}